import { decode } from 'base-64';

import { JWTClaims } from './Types';

// Function to decode Base64 string
function decodeBase64(base64: string) {
  try {
    return decode(base64);
  } catch (error) {
    console.error('Error decoding base64 string', error);

    return null;
  }
}

export const validateToken = (
  token?: string | null,
  allowedRoleIds?: string[],
  resourceAppKey?: string,
  resourceOrgKey?: string
): boolean => {
  if (!token) {
    return false;
  }

  if (!resourceAppKey && !resourceOrgKey) {
    return false;
  }

  try {
    const payload = token.split('.')[1];
    const decodedPayload = decodeBase64(payload);

    if (!decodedPayload) {
      return false;
    }

    const claims = JSON.parse(decodedPayload) as JWTClaims;

    if (!claims.exp) {
      return false;
    }

    if (isNearlyExpired(claims.exp)) {
      return false;
    }

    if (resourceAppKey && claims.apps && claims.apps[resourceAppKey]) {
      if (!allowedRoleIds?.length) {
        return true;
      }

      return (
        claims.apps[resourceAppKey].roles &&
        claims.apps[resourceAppKey].roles.some((roleId) =>
          allowedRoleIds.includes(roleId)
        )
      );
    }

    if (resourceOrgKey && claims.orgs && claims.orgs[resourceOrgKey]) {
      if (!allowedRoleIds?.length) {
        return true;
      }

      return (
        claims.orgs[resourceOrgKey].roles &&
        claims.orgs[resourceOrgKey].roles.some((roleId) =>
          allowedRoleIds.includes(roleId)
        )
      );
    }
  } catch {}

  return false;
};

export const validateSapToken = (token?: string | null): boolean => {
  if (!token) {
    return false;
  }

  try {
    const payload = token.split('.')[1];
    const decodedPayload = decodeBase64(payload);

    if (!decodedPayload) {
      return false;
    }

    const claims = JSON.parse(decodedPayload) as JWTClaims;

    if (!claims.exp) {
      return false;
    }

    if (isNearlyExpired(claims.exp)) {
      return false;
    }

    return true;
  } catch {}

  return false;
};

const isNearlyExpired = (expMsec: number): boolean => {
  const now = new Date();
  const utcNow = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
    now.getUTCMilliseconds()
  );

  const msecRemaining = expMsec * 1000 - utcNow;
  const fiveMinutesInMsec = 5 * 60 * 1000;

  return msecRemaining < fiveMinutesInMsec;
};
